<template>
    <div class="about-app-container flex row center">
        <div class="abt-app-item abt-content-wrap">
            <div class="abt-content-item abt-pg-img mobile-margin">
                <img :src="require('../../assets/Desktop/About_Us/03-img.svg')" alt="Page 3">
            </div>
            <div class="abt-content-item abt-content-container" style="text-align:left;">
                <div class="abt-cont md-container">
                    <p class="abt-subtitle">ROYAL EXPERIENCE</p>
                </div>
                <div class="abt-cont mobile-margin">
                    <h1 class="abt-title">The Application</h1>
                </div>
                <div class="mobile-margin">
                    <img class="mobile-img" :src="require('../../assets/Mobile/Mobile_About_Us/about_Phone_IMG_Mobile.png')" alt="About Application">
                </div>
                <div class="abt-cont mobile-margin">
                    <p class="abt-text">Royal Experience is a luxury full service concierge and hospitality company that simplifies the client's life Through innovative software that can be found at the users fingertips. Wherever a customer is traveling and whatever they want to experience, the business R.E, can accommodate them efficiently, conveniently and without the hassle of time consuming event planning.</p>
                </div>
                <div class="abt-cont abt-content-btn mobile-margin">
                    <button class="abt-button" style="display:none;">LEARN MORE</button>
                </div>
            </div>
        </div>
        <div class="abt-app-item abt-img-wrap md-container">
            <img :src="require('../../assets/Desktop/About_Us/about_phone_img.png')" alt="iPhone Image">
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
            }
        }
    }
</script>

<style scoped>
    @media (max-width: 880px) {
        .about-app-container {
            height: 1000px !important;
            flex-direction: column !important;
        }

        .abt-content-wrap {
            flex-direction: column !important;
            justify-content: center !important;
            margin: 0 auto auto auto !important;
        }

        .abt-content-container {
            text-align: center !important;
        }

        .mobile-img {
            display:block !important;
            margin: 45px auto !important;
        }

        .mobile-margin {
            margin: 25px auto !important;
        }
    }

    .mobile-img {
        display:none;
    }

    .about-app-container {
        height: 875px;
    }

    .abt-content-item {

    }

    .abt-img-wrap {
        margin: 2.5% 0 0 60px;
    }

    .abt-content-wrap {
        display: flex;
        flex-direction: row;
        margin: 5.5% 60px 0 0;
    }

    .abt-pg-img {
        margin: 6% 5% 0 0;
    }

    .abt-subtitle {
        color: #244F76;
        font-family: Trirong;
        font-size: 12px;
        font-weight: bold;
        letter-spacing: 2.31px;
        line-height: 20px;
    }

    .abt-title {
        color: #333333;
        font-family: Trirong;
        font-size: 32px;
        font-weight: 800;
        line-height: 44px;
    }

    .abt-text {
        width: 374px;
        color: #333333;
        font-family: Trirong;
        font-size: 16px;
        letter-spacing: 1px;
        line-height: 28px;
    }

    .abt-button {
        height: 52px;
        width: 167px;
        background-color: #244F76;
        color: #FFFFFF;
        font-family: Oswald;
        font-size: 11px;
        font-weight: 500;
        letter-spacing: 3.67px;
        line-height: 15px;
        cursor: pointer;
        outline: none;
    }

    .abt-content-btn {
        margin: 40px 0 0 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/about/About_Application.vue